import { api } from '../api-client.config';
import { useQuery } from '@tanstack/react-query';
import { ContestType } from 'src/types/domain.types';

const getContest = (contestId: number): Promise<{ contest: ContestType }> =>
  api.get(`/contests/${contestId}`);

export const useGetContestQuery = (contestId: number) =>
  useQuery({
    queryKey: ['contests', contestId],
    queryFn: () => getContest(contestId),
    enabled: !!contestId,
    select: (data) => data.contest,
  });
